const EMBEDDABLE_CUSTOMER_SERVICE_HOSTS = new Set(["direct.lc.chat"]);

export const shouldOpenCustomerServiceInIframe = (
  url?: string | null
): boolean => {
  if (!url) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    return (
      parsedUrl.protocol === "https:" &&
      EMBEDDABLE_CUSTOMER_SERVICE_HOSTS.has(parsedUrl.hostname.toLowerCase())
    );
  } catch {
    return false;
  }
};
